import { lazy } from 'react';

const AlumniSurveyInvitation = lazy(() =>
  import('./components/AlumniSurveyInvitation'),
);
const ConfirmDeleteSurvey = lazy(() =>
  import('./components/ConfirmDeleteSurvey'),
);
const ConfirmSurveyEdits = lazy(() =>
  import('./components/ConfirmSurveyEdits'),
);
const CreateSurveyWindow = lazy(() =>
  import('./components/CreateSurveyWindow/CreateSurveyWindow'),
);

export default {
  ALUMNI_SURVEY_INVITATION: AlumniSurveyInvitation,
  CONFIRM_DELETE_SURVEY: ConfirmDeleteSurvey,
  CONFIRM_SURVEY_EDITS: ConfirmSurveyEdits,
  CREATE_SURVEY_WINDOW: CreateSurveyWindow,
};
